import React, { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse } from '@mui/material';
import { Tab } from '../../../common/components/Tabs/Tabs';
import HoverDropdownButton from '../../../common/components/Form/HoverDropdownButton';
import { isMobile } from '../../../common/services/isMobile';
import MenuItem from '../../../common/components/MenuItem/MenuItem';

export default function ({ label, value, disabled, menuItems, menuItemClick, isFlat, key, fullWidth, modal }) {
  const [isFlatExpanded, setFlatExpanded] = useState(false);

  if (isFlat) {
    return (
      <>
        <MenuItem key={key} value={value} onClick={() => setFlatExpanded(!isFlatExpanded)} isFlat>
          {label} {isFlatExpanded ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>
        <Collapse in={isFlatExpanded} timeout="auto" unmountOnExit>
          {menuItems.map((item) => (
            <MenuItem key={item.value} onClick={() => menuItemClick(item.value)} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Collapse>
      </>
    );
  }

  if (isMobile) {
    return (
      <Tab
        label={label}
        value={value}
        items={menuItems}
        handleMenuItemClick={(value) => menuItemClick(value)}
        disabled={disabled}
        key={key}
        fullWidth={fullWidth}
        withChild
      />
    );
  }

  return (
    <Tab
      fullWidth={fullWidth}
      label={
        <HoverDropdownButton fullWidth={fullWidth} label={label} placement="bottom-start" modal={modal}>
          {menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value} onClick={() => menuItemClick(item.value)}>
              {item.label}
            </MenuItem>
          ))}
        </HoverDropdownButton>
      }
      value={value}
      key={key}
      disabled={disabled}
      withChild
    />
  );
}
